
export function formatSnakeToCapitalized(value, fallback = '-') {
  if (value == null || value === '') return fallback;
  const str = String(value).trim();
  if (!str) return fallback;
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function formatFirstLetterCapitalized(value, fallback = '-') {
  if (value == null || value === '') return fallback;
  const str = String(value).trim();
  if (!str) return fallback;
  return str.charAt(0).toUpperCase() + str.slice(1);
}
